/**
 * Product Related Vue component
 * ------------------------------------------------------------------------------
 * Main template in sections/product__related.liquid
 *
 * Recommended products retrieved via Product Recommendations Ajax API
 * https://shopify.dev/docs/themes/ajax-api/reference/product-recommendations
 *
 * Example usage:
 * <product-related inline-template product-id="{{ product.id }}"/>
 */

import axios from 'axios'
import ProductItem from './product-item.js'

import { transformAjaxProduct } from './../utils/data'

export default {
  components: {

    ProductItem
  },

  props: {
    productId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      isLoading: true,
      recommendedProducts: []
    }
  },

  async created () {
    // Recommended products
    this._getRecommendedProducts()
  },

  methods: {
    _getRecommendedProducts () {
      axios.get(`/recommendations/products.json?product_id=${this.productId}`).then(({ data }) => {
        this.recommendedProducts = data.products.map(product => transformAjaxProduct(product)).splice(1, 4)
        this.isLoading = false
      }).catch((error) => {
        console.log('Recommended products', error)
        throw error
      })
    }
  }
}
